var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstMoneyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.353346,
    y: 0.612014,
    width: 55.38,
    height: 55.0271,
    rx: 8.5,
    transform: "matrix(0.966077 0.258254 -0.259385 0.965774 14.702 -0.0703062)",
    fill: "#241A57",
    fillOpacity: 0.53,
    stroke: "url(#paint0_linear_1877_15306)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Linear / Money / Wad Of Money",
    clipPath: "url(#clip0_1877_15306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7867 40.6807C27.0731 39.9551 25.7163 39.5923 24.9158 38.6805C24.5692 38.2857 24.3038 37.8266 24.1347 37.3293C23.7441 36.1805 24.1068 34.8237 24.8324 32.1101C25.558 29.3965 25.9208 28.0397 26.8327 27.2392C27.2274 26.8926 27.6866 26.6272 28.1839 26.4581C29.3327 26.0675 30.6895 26.4303 33.4031 27.1558L39.1994 28.7057C41.913 29.4313 43.2698 29.7941 44.0703 30.706C44.4169 31.1007 44.6823 31.5599 44.8514 32.0572C45.242 33.206 44.8792 34.5628 44.1537 37.2763C43.4281 39.9899 43.0653 41.3467 42.1534 42.1473C41.7587 42.4938 41.2995 42.7592 40.8022 42.9283C39.6534 43.319 38.2966 42.9562 35.583 42.2306L29.7867 40.6807Z",
    stroke: "#7057ED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.3699 31.0176C30.7693 30.5896 29.1248 31.5403 28.6968 33.1409C28.2688 34.7415 29.2194 36.386 30.8201 36.814",
    stroke: "#7057ED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.1671 32.5708C39.7677 32.9988 40.7183 34.6433 40.2903 36.2439C39.8623 37.8446 38.2178 38.7952 36.6172 38.3672",
    stroke: "#7057ED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.4023 27.1562L29.9151 40.1981",
    stroke: "#7057ED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.1992 28.7031L35.712 41.745",
    stroke: "#7057ED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15306",
    x1: 28.19,
    y1: -1.11316e-8,
    x2: 28.5612,
    y2: 64.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249483,
    stopColor: "#6E5BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_15306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(26 20) rotate(14.97)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMoneyImg);
export default __webpack_public_path__ + "static/media/FirstMoneyImg.238778c1a3ce58658826797dd32e5e75.svg";
export { ForwardRef as ReactComponent };